import React from 'react';
import styles from './PlanQueue.styles';
import { PlanErrorKey, planErrorMessages } from './PlanQueue.types';

interface PlanQueueErrorProps {
  planKey: PlanErrorKey;
}

export const PlanQueueError = ({ planKey }: PlanQueueErrorProps) => (
  <div className={styles.errorContainer}>
    <span className={styles.errorMessage}>⚠️ {planErrorMessages[planKey]}</span>
  </div>
);
